import React, { useRef } from 'react';
import { Box, Container, Grid, IconButton, Typography } from '@mui/material';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { ChevronRight, ChevronLeft, Link2 } from 'react-feather';
import { text } from '@fortawesome/fontawesome-svg-core';

const BestList = ({ linkData }) => {
    const { t } = useTranslation();
    const containerRef = useRef(null);
    const scrollAmount = 300;

    const handlePrevClick = () => {
        if (containerRef.current) {
            containerRef.current.scrollLeft -= scrollAmount;
        }
    };

    const handleNextClick = () => {
        if (containerRef.current) {
            containerRef.current.scrollLeft += scrollAmount;
        }
    };

    return (
        <Container maxWidth="lg" disableGutters>
            <Box
                style={{
                    font: 'bold 20px Arial',
                    textAlign: 'center',
                    color: '#241F59',
                    textAlign: 'center',
                    marginTop:30
                    // marginLeft: '30px',
                }}
            >
                {t('socialLink')}
            </Box>
            <Box style={{ position: 'relative', padding: '10px 0' }}>
                {linkData && linkData.length > 0 ? (
                    <Box style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                        <IconButton onClick={handlePrevClick} style={{ zIndex: 10 }}>
                            <ChevronLeft />
                        </IconButton>
                        <Box
                            ref={containerRef}
                            style={{
                                display: 'flex',
                                overflowX: 'scroll',
                                scrollBehavior: 'smooth',
                                width: '100%',
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                                '&::-webkit-scrollbar': {
                                    display: 'none',
                                },
                            }}
                        >
                            <Grid container spacing={2} justifyContent="flex-start" wrap="nowrap">
                                {linkData.map((item) => (
                                    <Grid
                                        item
                                        key={item.id}
                                        xxl={3}
                                        xs={12}
                                        sm={6}
                                        md={3}
                                        lg={3}
                                        style={{ flex: '0 0 auto', minWidth: '50%' }}
                                    >
                                        <Link href={item.link} passHref>
                                            <Box
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    // margin: '0 0px',
                                                    borderRadius: 4,
                                                    padding: 30,
                                                    cursor: 'pointer',
                                                    textDecoration: 'none',
                                                }}
                                            >
                                                <Box
                                                    style={{
                                                        border: '1px solid #dee2e6',
                                                        height: 'auto',
                                                        // width: '100%',
                                                        borderRadius: 5,
                                                    }}
                                                >
                                                    <Box
                                                        style={{
                                                            backgroundPosition: 'center',
                                                            borderRadius: 4,
                                                            zIndex: 0,
                                                            // border: '2px solid #fff',
                                                            backgroundSize: 'cover',
                                                            backgroundRepeat: 'no-repeat',
                                                            backgroundImage: `url(${item.imageUrl})`,
                                                            height: 140,
                                                            width: 530,
                                                            paddingBottom: '56.25%',
                                                            boxShadow:
                                                                'rgba(31, 45, 61, 0.125) 0px 0px 30px',
                                                        }}
                                                    />
                                                </Box>
                                                <Box
                                                    style={{
                                                        fontSize: 18,
                                                        textAlign: 'center',
                                                        transition: 'none',
                                                        lineHeight: 1,
                                                        fontFamily: '"Roboto", sans-serif',
                                                        width: 500,
                                                        minHeight: 60,
                                                        marginTop: '-25px',
                                                        padding: 8,
                                                        backgroundColor: 'white',
                                                        fontWeight: 800,
                                                        zIndex: 10,
                                                        position: 'relative',
                                                        color: '#3a3973',
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'left',
                                                        marginLeft: 10,
                                                        marginRight: 10,
                                                        borderRadius: 4,
                                                        textDecoration: 'none',
                                                        boxShadow:
                                                            'rgba(31, 45, 61, 0.125) 0px 0px 30px',
                                                    }}
                                                >
                                                    <Link2 className="mr-[20px]" />
                                                    {i18n.language === 'en'
                                                        ? item.descriptionEng
                                                        : item.description}
                                                    <Link2 className="ml-[20px]" />
                                                </Box>
                                            </Box>
                                        </Link>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                        <IconButton onClick={handleNextClick} style={{ zIndex: 10 }}>
                            <ChevronRight />
                        </IconButton>
                    </Box>
                ) : (
                    <Typography variant="h6" align="center">
                        No data available
                    </Typography>
                )}
            </Box>
        </Container>
    );
};

export default BestList;
